module.exports = __webpack_public_path__ + "static/media/letterbox.d06ff2df.svg";